// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ViewKontaktListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchKontakteViewQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchKontakteView(): (
  aufgabeId: string,
  query: SearchKontakteViewQuery
) => Promise<ViewKontaktListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, query = {}) =>
      (await getAPI()).kontaktaufnahme.searchKontakteView({
        aufgabeId,
        ...query,
      }),
    [getAPI]
  );
}
